export enum ListDataColumn {
    NUMBER,
    DATE,
    DATETIME,
    YESNODATETIME,
    TEXT,
    VERSIONDATE,
    LOOKUP
}

export class ListColumn {

    private header!: string;
    private dataType!: ListDataColumn; 
    private sourceName!: string;
    private lookup?: string;

    constructor(header:string,dataType:ListDataColumn,sourceName:string, lookup?: string){
        this.header = header;
        this.dataType = dataType;
        this.sourceName = sourceName;
        this.lookup = lookup;
    }

    public getHeader(): string{
        return this.header;
    }

    public getSourceName(): string{
        return this.sourceName;
    }

    public getDataType(): ListDataColumn{
        return this.dataType;
    }

    public getLookup(): string | undefined {
        return this.lookup;
    }

}